import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import React, { Component, Fragment } from "react"

import { articleRejectionReasons } from "../../config/application-definitions"

type Props = {
    isOpen: boolean,
    toggle: void => boolean,
    reject: string => void
}

type State = {
    currentReason: string
}

export class FeedRejectionReasonModal extends Component<Props, State> {
    state = {
        currentReason: articleRejectionReasons[0]
    }

    handleInputChange = (event: SyntheticEvent<HTMLButtonElement>) => {
        this.setState({ currentReason: event.currentTarget.value })
    }

    handleSave = () => {
        this.props.reject(this.state.currentReason)
    }

    render() {
        const { isOpen, toggle } = this.props

        const { currentReason } = this.state

        return (
            <Modal
                isOpen={isOpen}
                toggle={toggle}
                className="modal-dialog-v-centered"
            >
                <ModalHeader toggle={toggle}>Reason for Rejection</ModalHeader>
                <ModalBody className="image-settings-modal">
                    <form>
                        {articleRejectionReasons.map((reason, index) => (
                            <Fragment key={reason.replace(/\s/g, "")}>
                                <input
                                    type="radio"
                                    checked={currentReason === reason}
                                    name="reason"
                                    id={reason.replace(/\s/g, "")}
                                    value={reason}
                                    onChange={this.handleInputChange}
                                />
                                <label htmlFor={reason.replace(/\s/g, "")}>
                                    {reason}
                                </label>
                                {articleRejectionReasons.length - 1 > index && (
                                    <br />
                                )}
                            </Fragment>
                        ))}
                    </form>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-cancel col" onClick={toggle}>
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary col"
                        onClick={this.handleSave}
                    >
                        Save
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}
